import React from 'react';
import { QuoteIcon, StarIcon } from 'lucide-react';
import { reviews } from '../data/reviews';
function Stars() {
  return <div className="flex" aria-label="5 out of 5 stars" data-id="element-271" data-mp="2hddqdrytf86q">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-[#FFC531] text-[#FFC531]" aria-hidden="true" data-id="element-272" data-mp="2ma45abyvvxqk" data-mpi={i} />)}
    </div>;
}
export function Reviews() {
  const [featured, ...rest] = reviews;
  return <section id="reviews" className="bg-white py-20 lg:py-28" data-id="element-273" data-mp="2w9d53lgfk6ku">
      <div className="mx-auto max-w-7xl px-5 lg:px-8" data-id="element-274" data-mp="30ayhl5p1yiui">
        <h2 className="font-display text-5xl font-extrabold uppercase leading-[0.95] text-ink lg:text-6xl" data-id="element-275" data-mp="309dj54zmafrd">
          Neighbors who <span className="text-brand" data-id="element-276" data-mp="3a103prxuhr6s">called the doctor</span>
        </h2>

        <div className="mt-12 grid gap-6 lg:grid-cols-[1.2fr_1fr]" data-id="element-277" data-mp="3a3du3nhkyf80">
          <figure className="flex flex-col rounded-2xl bg-brand p-8 text-white sm:p-10" data-id="element-278" data-mp="3f1nq20b4pjuo">
            <QuoteIcon className="h-10 w-10 text-white/40" aria-hidden="true" data-id="element-279" data-mp="3k0iiltywemrz" />
            <blockquote className="mt-5 font-display text-3xl font-semibold leading-snug sm:text-4xl" data-id="element-280" data-mp="2rd706b9diarc">
              “{featured.quote}”
            </blockquote>
            <figcaption className="mt-auto flex items-center justify-between gap-4 pt-8" data-id="element-281" data-mp="2mfxbixtt634k">
              <div data-id="element-282" data-mp="2hgke5j5b9dnq">
                <p className="font-display text-xl font-bold" data-id="element-283" data-mp="2dcw7d2oi6m3j">{featured.name}</p>
                <p className="text-sm text-white/80" data-id="element-284" data-mp="2dez8ahr71zn1">{featured.location}</p>
              </div>
              <Stars data-id="element-285" data-mp="3a59h7npxft24" />
            </figcaption>
          </figure>

          <div className="grid gap-6" data-id="element-286" data-mp="355ddlpl563n3">
            {rest.map(r => <figure key={r.name} className="flex flex-col rounded-2xl bg-canvas p-7" data-id="element-287" data-mp="30ctyupapx2gp">
                <div className="flex items-center justify-between gap-4" data-id="element-288" data-mp="2wc0axvx9znnt">
                  <p className="font-display text-2xl font-bold text-ink" data-id="element-289" data-mp="2w9xotmz8ueod">{r.title}</p>
                  <Stars data-id="element-290" data-mp="3suy0ukobvn26" />
                </div>
                <blockquote className="mt-3 leading-relaxed text-ink-muted" data-id="element-291" data-mp="3o2ek5eucgbt5">“{r.quote}”</blockquote>
                <figcaption className="mt-auto pt-5" data-id="element-292" data-mp="1m4uonkwmnx20">
                  <span className="font-bold text-ink" data-id="element-293" data-mp="1m7h384hxrctq">{r.name}</span>
                  <span className="text-ink-muted" data-id="element-294" data-mp="1r35xbsb6s1in"> · {r.location}</span>
                </figcaption>
              </figure>)}
          </div>
        </div>
      </div>
    </section>;
}